/**
 * Returns a shallow copy of a dropdown item without its legacy numeric `key` field. The
 * `ICountryObject` / `IDropDownItem` data shapes carry a `key` that aliases React's reserved `key`
 * prop, so React 19 warns when such an object is spread into JSX (`<Item {...item} />`). React never
 * forwards `key` as a prop anyway, so dropping it is behavior-preserving — it only silences the warning.
 */
export const omitReservedKey = <T extends object>(item: T): Omit<T, "key"> => {
    const copy = { ...item } as Omit<T, "key"> & { key?: unknown };
    delete copy.key;
    return copy;
};
